import { createContext } from "react";
import type {
  AnalyticsEvents,
  AnalyticsProperties,
} from "src/apps/hooks/analytics/useSendAnalyticEvent";

export type AnalyticsContextType = {
  sendEvent: (
    type: AnalyticsEvents,
    properties?: AnalyticsProperties,
    userProps?: AnalyticsProperties,
  ) => void;
};

export const AnalyticsContext = createContext<AnalyticsContextType>({
  sendEvent: () => {
    /* no-op default */
  },
});
